<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to employee list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="payroll-adustments-review" color="white"></help-link>
                    <div v-if="manual_adjustment">
                        <v-menu v-if="hasEditAndApproverRights||hasDeleteRights" left v-model="menu_status" offset-y :disabled="disabledForEditApprover"> 
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(manual_adjustment.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(manual_adjustment.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense >
                                <v-list-tile v-show="hasEditAndApproverRights&&(created_status||rejected_status)" :key="0" @click="showEdit" title="Edit Payroll Adjustment">
                                    <v-list-tile-title small>Edit</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasDeleteRights&&(created_status||rejected_status)" :key="1" @click="showDeleteConfirmation" title="Delete Payroll Adjustment">
                                    <v-list-tile-title small>Delete</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditAndApproverRights&&created_status" :key="2" @click="forReview" title="Set Status to For Review">
                                    <v-list-tile-title small>For Review</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditAndApproverRights&&(forReview_status||rejected_status)" :key="3" @click="approve" title="Approve Payroll Adjustment">
                                    <v-list-tile-title small>Approve</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditAndApproverRights&&(forReview_status||approved_status||processed_status)" :key="4" @click="reject" title="Reject Payroll Adjustment">
                                    <v-list-tile-title small>Reject</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <v-menu v-if="!hasEditAndApproverRights&&(hasEditRights||hasApproverRights||hasDeleteRights)" left v-model="menu_status" offset-y :disabled="disabledForEdit||disabledForApprover"> 
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(manual_adjustment.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(manual_adjustment.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense >
                                <v-list-tile v-show="hasEditRights&&(created_status||rejected_status)" :key="0" @click="showEdit" title="Edit Payroll Adjustment">
                                    <v-list-tile-title small>Edit</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasDeleteRights&&(created_status||rejected_status)" :key="1" @click="dialogDelete=true" title="Delete Payroll Adjustment">
                                    <v-list-tile-title small>Delete</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditRights&&created_status" :key="2" @click="forReview" title="Set Status to For Review">
                                    <v-list-tile-title small>For Review</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasApproverRights&&(forReview_status||rejected_status)" :key="3" @click="approve" title="Approve Payroll Adjustment">
                                    <v-list-tile-title small>Approve</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasApproverRights&&(forReview_status||approved_status||processed_status)" :key="4" @click="reject" title="Reject Payroll Adjustment">
                                    <v-list-tile-title small>Reject</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" class="mt-0"></v-progress-linear>
            </v-card>

            <v-alert v-if="!loading&&adjustment_processed_status" :value="true" color="info" icon="info" outline class="mt-8">
                The payroll adjustment has been <b>Processed</b> already. You will not be able to change this record.
            </v-alert>
            <v-alert v-if="!loading&&!adjustment_processed_status" :value="true" color="info" icon="info" outline dismissible class="mt-8">
                Only <b>Approved</b> adjustments will be included in payroll processing.
            </v-alert>  

            <!-- details -->
            <v-card v-if="!loading" class="elevation-1 mt-10 mb-5">
                <v-toolbar flat height="35px" class="font-weight-bold">
                    <span class="primary--text">ADJUSTMENT DETAILS</span>
                    <v-spacer></v-spacer>
                </v-toolbar>                
                <v-layout row wrap>
                    <v-flex xs12 sm6 class="mt-10 mb-10">
                        <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Requested By :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <v-chip @click="viewUserProfile(manual_adjustment, $store.state.userId)" class="user-chip-container">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(manual_adjustment.userId)"></v-img>
                                    </v-avatar>
                                    {{manual_adjustment.firstName}} {{manual_adjustment.lastName}}
                                </v-chip>
                            </v-flex>  
                        </v-layout>                             
                        <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Journal Type :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                               {{manual_adjustment.transType==1?'Credit to Payroll':'Debit to Payroll'}}
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Adjustment Type :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                               {{manual_adjustment.manualAdjustmentName}}
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Tax Treatment :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <span v-if="manual_adjustment.transType==1">
                                    <span v-if="manual_adjustment.addToTaxableIncome">Taxable (added to taxable income)</span>
                                    <span v-else>Non-taxable (not added to taxable income)</span>
                                </span>
                                <span v-else>
                                    <span v-if="manual_adjustment.deductFromTaxableIncome">Deductible from taxable income</span>
                                    <span v-else>Not deductible from taxable income</span>
                                </span>
                            </v-flex>  
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6 class="mt-10 mb-10">
                         <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Amount : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                ₱{{numFormat.formatNumber(manual_adjustment.amount)}}
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Created On :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{manual_adjustment.createdOn|moment('MMM DD, YYYY')}}
                            </v-flex>  
                        </v-layout> 
                         <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Cut Off Period : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{getCoverageDesc}}
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Note : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                 {{manual_adjustment.remarks}}
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Show Notes On Reports : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <span v-if="manual_adjustment.showNotesOnReports">Yes</span>
                                <span v-else>No</span>
                            </v-flex>  
                        </v-layout>
                    </v-flex>
                </v-layout>              
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>
        
        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deleteManualAdjustment"></delete>
        </v-dialog>
        <v-dialog v-model="dialogManualAdjustments" width="700" persistent>   
            <adjustments ref="adjustmentsRef" :dialogManualAdjustments.sync="dialogManualAdjustments" @send="getManualAdjustments(false)"></adjustments>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>
<script>

import commonfn from '@/common/functions'   //for refactor
import manualAdjustmentsApi from '@/api/manualadjustments'
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import { hasDeleteRights, hasEditRights, hasApproverRights } from '@/helpers/access-permissions'

export default {     
    name: 'Adjustments',
    metaInfo: {
        title: 'Adjustments',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create Manual Adjustments' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'adjustments': () => import('@/components/Payroll/ManualAdjustments'),
        'delete': () => import('@/components/BasicPopups/Delete'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        return {
            commonfn,
            numFormat,
            awsS3Helper,
            error: false,
            errorMessage: '',
            dialogDelete: false,
            menu_status: false,
            loading: false,
            loading_status: false,
            loading_delete: false,
            snackbar: false,
            snackbarText: '',
            message: null,
            dialogManualAdjustments: false,
            manual_adjustment: null,
            cutoff_period: null,
        }
    },
    methods: {  
        showDeleteConfirmation(){
            this.$refs.refDeleteComponent.setMessage("Delete this Payroll Adjustment?")
            this.dialogDelete = true
        },
        async forReview() {
            try{
                this.loading_status = true
                const response = await manualAdjustmentsApi.forReview(this.manualAdjustmentId)
                if (response && response.status == 200) {
                    await this.getManualAdjustments(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async reject() {
            try{
                this.loading_status = true
                const response = await manualAdjustmentsApi.reject(this.manualAdjustmentId)
                if (response && response.status == 200) {
                    await this.getManualAdjustments(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approve() {
            try{
                this.loading_status = true
                const response = await manualAdjustmentsApi.approve(this.manualAdjustmentId)
                if (response && response.status == 200) {
                    await this.getManualAdjustments(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async deleteManualAdjustment() {
            try{
                this.loading_delete = true
                await manualAdjustmentsApi.delete(this.manualAdjustmentId)
                this.loading_delete = false
                this.dialogDelete = false
                this.$router.push(`/payroll/adjustments/${this.cutoff_period.cutoffId}`)
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
        showEdit() {
            this.$refs.adjustmentsRef.setUpdate(this.manual_adjustment)
            this.dialogManualAdjustments = true
        },
        async getManualAdjustments(show_loading){
            try{
                if (show_loading) this.loading = true
                const response = await manualAdjustmentsApi.getById(this.manualAdjustmentId)
                if (response && response.status == 200) {
                    this.manual_adjustment = response.data.manualAdjustment
                    this.cutoff_period = response.data.cutoffItem
                }
                if (show_loading) this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getManualAdjustments(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Adjustments Details'
        })
        this.getManualAdjustments(true)
    },
    computed: {
        pageQueryId() {
            return `adjustment${this.manualAdjustmentId}`
        },
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return hasApproverRights(this.$router.currentRoute.path)
        },
        hasEditAndApproverRights() {
            return this.hasEditRights && this.hasApproverRights
        },
        manualAdjustmentId() {
            return this.$route.params.manualAdjustmentId
        },
        commentsData() {
            if (this.manual_adjustment) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: this.manual_adjustment.userId,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.manual_adjustments,
                    notificationTypeId: notificationTypes.manual_adjustments
                }
            }
        },
        getCoverageDesc() {
            //todo - convert this to reusable helper function
            if (this.loading) return;
             
            const start = this.$moment(this.cutoff_period.cutoffStart);
            const end = this.$moment(this.cutoff_period.cutoffEnd);

            const sameYear = start.year() === end.year();
            const sameMonth = start.month() === end.month() && sameYear;

            if (sameMonth) {
                // Aug 1–15, 2025
                return `${start.format('MMM D')} - ${end.format('D, YYYY')}`;
            }

            if (sameYear) {
                // Aug 25 – Sep 10, 2025
                return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}`;
            }

            // Dec 26, 2025 – Jan 10, 2026
            return `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;

        },
        frozenPeriod(){
            if (this.cutoff_period)
                return this.cutoff_period.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod(){
            if (this.cutoff_period)
                return this.cutoff_period.status==commonfn.getStatusCode('Closed')
        },
        created_status() {
            if (this.manual_adjustment)
                return this.manual_adjustment.status==commonfn.getStatusCode('Created')
        },
        forReview_status() {
            if (this.manual_adjustment)
                return this.manual_adjustment.status==commonfn.getStatusCode('For Review')
        },
        approved_status() {
            if (this.manual_adjustment)
            return this.manual_adjustment.status==commonfn.getStatusCode('Approved')
        },
        rejected_status() {
            if (this.manual_adjustment)
            return this.manual_adjustment.status==commonfn.getStatusCode('Rejected')
        },
        processed_status() {
            if (this.manual_adjustment)
                return this.manual_adjustment.status == commonfn.getStatusCode('Processed')
        },
        adjustment_processed_status() {
            if (this.manual_adjustment)
                return this.manual_adjustment.status == commonfn.getStatusCode('Adjustments Processed')
        },
        approved_Timesheet() {
            if (this.cutoff_period)
                return this.cutoff_period.timeReportStatus==commonfn.getStatusCode('Approved')
        },
        disabledForEdit() {
            return this.hasEditRights&&(this.forReview_status||this.approved_status||this.adjustment_processed_status)
        },
        disabledForApprover() {
            return this.hasApproverRights&&(this.created_status||this.adjustment_processed_status)
        },
        disabledForEditApprover() {
            return this.adjustment_processed_status
        }
    }
}
</script>
<style scoped>
.form-row {
    padding:0px 20px 0px 50px;
}
.form-row-mobile {
    padding:0px 20px 0px 20px;
}
</style>